var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthDecorLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 145,
    viewBox: "0 0 118 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4867 60.638L42.3081 59.4477C41.2194 58.3482 41.1456 56.601 42.1376 55.4135L86.7788 1.97815C87.7292 0.840509 89.368 0.5676 90.6358 1.33586L94.2332 3.51579C95.8409 4.49002 96.1668 6.68589 94.9113 8.08504L47.8514 60.5308C46.6983 61.8158 44.7014 61.8648 43.4867 60.638Z",
    fill: "#ECAF2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7118 101.012L70.1188 100.51C68.979 99.5468 68.7231 97.8899 69.5183 96.6238L102.158 44.6555C102.974 43.3561 104.637 42.8795 106.014 43.5503L108.667 44.8425C110.306 45.6414 110.856 47.7094 109.831 49.222L75.1314 100.399C74.1302 101.876 72.0718 102.161 70.7118 101.012Z",
    fill: "#ECAF2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6368 88.3971L14.2667 141.393C13.0039 143.051 10.6411 143.379 8.9804 142.126C7.35032 140.897 6.99339 138.593 8.17432 136.922L46.3767 82.892C47.467 81.3499 49.4848 80.7778 51.2182 81.5192L53.0357 82.2967C55.4282 83.3201 56.2165 86.3234 54.6368 88.3971Z",
    fill: "#ECAF2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthDecorLines);
export default __webpack_public_path__ + "static/media/auth-decor-lines.a3bffade.svg";
export { ForwardRef as ReactComponent };